module.exports = __webpack_public_path__ + "static/media/expiredTaxDataModal.ef1569c8.svg";